(function autoCloseDetails() {
  // matchMedia is CSSOM-cached and does not trigger forced reflow on read,
  // unlike window.innerWidth which queries live layout.
  const mobileMedia = matchMedia('(max-width: 749px)');

  document.addEventListener('click', function (event) {
    // Early exit: most clicks happen when no auto-close <details> is open.
    // querySelectorAll on detached attribute selectors is cheap (no layout).
    const openDetails = document.querySelectorAll('details[data-auto-close-details][open]');
    if (openDetails.length === 0) return;

    const closingOn = mobileMedia.matches ? 'mobile' : 'desktop';

    for (const element of openDetails) {
      const attr = element.getAttribute('data-auto-close-details');
      if (!attr || !attr.includes(closingOn)) continue;
      if (event.target instanceof Node && element.contains(event.target)) continue;
      element.removeAttribute('open');
    }
  });
})();
